import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=c2e6c7da&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2e6c7da')) {
      api.createRecord('c2e6c7da', component.options)
    } else {
      api.reload('c2e6c7da', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=c2e6c7da&", function () {
      api.rerender('c2e6c7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22omdsZ9bvfzf/JS/comp/CurrentYear.vue"
export default component.exports